"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.traverse = void 0;
const traverse = (ast, visitor) => {
    const traverseArray = (array, parent) => {
        for (let i = 0; i < array.length; i++) {
            traverseNode(array[i], parent);
        }
    };
    const traverseNode = (node, parent) => {
        const methods = visitor[node.type];
        if (methods && methods.enter) {
            methods.enter(node, parent);
        }
        switch (node.type) {
            case 'Program':
                traverseArray(node.body, node);
                break;
            case 'BlockStatement':
                traverseArray(node.body, node);
                break;
            case 'IfStatement':
                {
                    traverseNode(node.consequent, node);
                    if (node.alternate !== null) {
                        traverseNode(node.alternate, node);
                    }
                }
                break;
            case 'VariableDeclaration':
                traverseArray(node.declarations, node);
                break;
            case 'VariableDeclarator':
                traverseNode(node.init, node);
                break;
            case 'ExpressionStatement':
                traverseNode(node.expression, node);
                break;
            case 'CallExpression':
                traverseNode(node.callee, node);
                traverseArray(node.arguments, node);
                break;
            case 'ArrayExpression':
                traverseArray(node.elements, node);
                break;
            case 'MemberExpression':
                traverseNode(node.object, node);
                traverseNode(node.property, node);
                break;
            case 'ObjectExpression':
                traverseArray(node.properties, node);
                break;
            case 'Property':
                traverseNode(node.key, node);
                traverseNode(node.value, node);
                break;
            case 'AssignmentExpression':
                traverseNode(node.left, node);
                traverseNode(node.right, node);
                break;
            case 'ArrowFunctionExpression':
                traverseArray(node.params, node);
                traverseNode(node.body, node);
                break;
            case 'BinaryExpression':
                traverseNode(node.left, node);
                traverseNode(node.right, node);
                break;
            case 'UnaryExpression':
                traverseNode(node.argument, node);
                break;
            case 'SpreadElement':
                traverseNode(node.argument, node);
                break;
            case 'Identifier':
            case 'Literal':
                break;
            default:
                throw new Error(`Undefined AST node type: ${node.type}`);
        }
        if (methods && methods.exit) {
            methods.exit(node, parent);
        }
    };
    traverseNode(ast, ast);
};
exports.traverse = traverse;
